import { render, staticRenderFns } from "./other-package.vue?vue&type=template&id=0aba38b5&"
import script from "./other-package.vue?vue&type=script&lang=js&"
export * from "./other-package.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports